import forDevice from '../../../common/hoc/for-device';
import RecentPostsDesktop from './recent-posts-desktop';
import RecentPostsMobile from './recent-posts-mobile';

export default forDevice(RecentPostsMobile, RecentPostsDesktop);
